module.exports = __webpack_public_path__ + "static/media/phone-fixed-voice.dc214e89.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/phone-fixed-voice.svg
// module id = 3192
// module chunks = 0